
(function ($) {

  'use strict';

  var etPos = [];
  var tPos = [];

  $(window).on('load', function () {
    updateOffsetArray();
  });

  $(window).resize(function () {
    updateOffsetArray();
  });

  $(window).scroll(function () {
    var scrollHeight = $(document).scrollTop();
    // Lazy loaded images may require update to offset array.
    updateOffsetArray();

    for (var i = 0; i < etPos.length; i++) {
      var $stickyParents = $('.sticky-element-parent');
      var $stickyParent = $stickyParents.eq(i);
      if (scrollHeight >= (etPos[i][0]) && scrollHeight <= (etPos[i][1] - etPos[i][2])) {
        $stickyParent.find('.sticky-element').addClass('fixed').removeClass('bottom');
      }
      else if (scrollHeight > (etPos[i][1] - etPos[i][2]) && $stickyParent.height() > ($stickyParent.find('.sticky-element').height())) {
        $stickyParent.find('.sticky-element').removeClass('fixed').addClass('bottom');
      }
      else {
        $stickyParent.find('.sticky-element').removeClass('fixed').removeClass('bottom');
      }
    }
  });

  function updateOffsetArray() {
    var $stickyParents = $('.sticky-element-parent');
    etPos = [];
    $stickyParents.each(function () {
      tPos = $(this).offset();
      etPos.push([tPos.top, tPos.top + $(this).height(), $(this).find('.sticky-element').height()]);
    });
  }

})(jQuery);

// # sourceMappingURL=maps/sticky-element.js.map
